import { render, staticRenderFns } from "./CareimageList.vue?vue&type=template&id=ff19ac14&scoped=true&lang=pug"
import script from "./CareimageList.vue?vue&type=script&lang=ts"
export * from "./CareimageList.vue?vue&type=script&lang=ts"
import style0 from "./CareimageList.vue?vue&type=style&index=0&id=ff19ac14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff19ac14",
  null
  
)

export default component.exports